module.exports = __webpack_public_path__ + "static/img/1.05ab8ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR22/1.jpg
// module id = /nFL
// module chunks = 1